import { isEqual, sortBy } from "lodash-es";

export const getSetFilterCount = <T>(
  filters: T | undefined,
  defaultFilters: T | undefined,
) => {
  if (!filters || !defaultFilters) {
    return 0;
  }

  return (Object.keys(filters) as Array<keyof typeof filters>).reduce(
    (acc, key) => {
      const value = filters[key];
      const defaultValue = defaultFilters[key];

      if (Array.isArray(value) && Array.isArray(defaultValue)) {
        // the easiest way to compare arrays content, we assume that they contain primitives
        const isSame =
          JSON.stringify([...value].sort()) ===
          JSON.stringify([...defaultValue].sort());

        return isSame ? acc : acc + 1;
      }

      return value === defaultValue ? acc : acc + 1;
    },
    0,
  );
};

export const getFilterValue = <T>(currentValue: T, defaultValue: T) => {
  if (Array.isArray(currentValue) && Array.isArray(defaultValue)) {
    if (currentValue.length !== defaultValue.length) {
      return currentValue;
    }

    return isEqual([...currentValue].sort(), [...defaultValue].sort())
      ? undefined
      : currentValue;
  }

  return isEqual(currentValue, defaultValue) ? undefined : currentValue;
};

export const getPricesFilterValues = (
  currentValue: [number, number] | undefined,
  defaultValue: [number, number],
) => {
  if (!currentValue || isEqual(sortBy(currentValue), sortBy(defaultValue))) {
    return {
      minPrice: undefined,
      maxPrice: undefined,
    };
  }

  return {
    minPrice: currentValue[0],
    maxPrice: currentValue[1],
  };
};
